/** @file serverInfo: reads `GET /api/v1/health` (the server version and the optional build). */

/** The server's build: short git SHA and ISO time of the deploy (absent on a server that does not say). */
export type ServerBuild = { sha: string; at: string };

/** The health reply as the shell reads it (`packages/api`'s `health()` type has no `build` yet). */
export type HealthReply = { ok: true; version: string; build?: ServerBuild };

const base = (url: string): string => url.replace(/\/+$/, '');

/** GET `path` under `url` with the session cookie; throws on a non-2xx status. */
async function get(url: string, path: string, fetchFn: typeof fetch): Promise<Response> {
  const res = await fetchFn(`${base(url)}${path}`, { credentials: 'include' });
  if (!res.ok) throw new Error(`${path}: HTTP ${String(res.status)}`);
  return res;
}

/** `GET /api/v1/health`. */
export async function serverInfo(url: string, fetchFn: typeof fetch = fetch): Promise<HealthReply> {
  return (await (await get(url, '/api/v1/health', fetchFn)).json()) as HealthReply;
}
